module.exports = "<i class=\"spinner fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i>\n<img #_img [class]=\"_class\" [title]=\"_title\" [alt]=\"_alt\" (load)=\"_loaded(true)\" [src]=\"_src\"/>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/preload-image/preload-image.component.html
// module id = ./src/app/shared/preload-image/preload-image.component.html
// module chunks = main